import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BellOff, BellRing, Loader2, Tag } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";
import { pushSupported } from "../../lib/pwa";

// si este celular tenía notificaciones de ese tramo, también las apaga
const unroutePush = async (route) => {
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.getRegistration("/");
  const sub = await reg?.pushManager.getSubscription();
  if (sub) await api.post("/push/unsubscribe", { endpoint: sub.endpoint, route });
};

const AlertRow = ({ a, onOff }) => {
  const [busy, setBusy] = useState(false);
  const off = async () => {
    setBusy(true);
    try {
      await api.delete(`/my/price-alerts/${a.id}`);
      await unroutePush(`${a.origin}|${a.destination}`).catch(() => {});
      toast.success(`Listo, no te avisamos más de ${a.origin} → ${a.destination}`);
      onOff(a.id);
    } catch (err) { toast.error(apiError(err)); setBusy(false); }
  };
  const link = `/pasajes?o=${encodeURIComponent(a.origin)}&d=${encodeURIComponent(a.destination)}`;
  return (
    <li data-testid={`my-alert-${a.id}`} className="flex flex-wrap items-center justify-between gap-3 p-4">
      <span className="flex items-center gap-3">
        <BellRing className="h-4 w-4 shrink-0 text-[var(--forest)]" />
        <span><b>{a.origin} → {a.destination}</b>
          {a.promo_pct
            ? <Link to={link} data-testid={`my-alert-${a.id}-promo`} className="mt-1 flex items-center gap-1 text-xs font-bold text-[var(--forest)] underline-offset-4 hover:underline"><Tag className="h-3 w-3" /> PROMO -{a.promo_pct}% vigente · ver salidas</Link>
            : <span className="block text-xs text-[var(--muted-ink)]">Te avisamos cuando entre en promo</span>}
        </span>
      </span>
      <button type="button" onClick={off} disabled={busy} data-testid={`my-alert-${a.id}-off`} className="inline-flex items-center gap-2 rounded-full border border-black/10 px-4 py-2 text-sm font-bold transition-colors hover:bg-[var(--paper)] disabled:opacity-60">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <BellOff className="h-4 w-4" />} Apagar
      </button>
    </li>
  );
};

/** Avisos de promo del pasajero: los ve y los apaga (email y notificación de este celular). */
export const MyPriceAlerts = () => {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/my/price-alerts").then((r) => setList(Array.isArray(r.data) ? r.data : [])).catch(() => setList([])); }, []);
  if (!list) return <Loader2 className="h-5 w-5 animate-spin" />;
  if (!list.length) return <p data-testid="my-alerts-empty" className="rounded-2xl bg-[var(--paper)] p-5 text-sm">No tenés avisos de promo. Tocá un destino en la portada y pedí "Avisame cuando este tramo tenga promo".</p>;
  return (
    <ul data-testid="my-alerts" className="divide-y divide-black/5 rounded-2xl bg-white ring-1 ring-black/5">
      {list.map((a) => <AlertRow key={a.id} a={a} onOff={(id) => setList((l) => l.filter((x) => x.id !== id))} />)}
    </ul>
  );
};
